import React, { useState, useRef, useEffect } from "react";


export default function Chatbot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { id: "sys-1", role: "system", text: "👋 Hi! I'm your support assistant. How can I help today?" },
  ]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);

  // Scroll to bottom on new messages
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  // Fake bot replies
  function fakeBotReply(userMessage) {
    const lower = userMessage.toLowerCase();
    if (lower.includes("hello") || lower.includes("hi")) return "Hello! 👋 How can I assist you today?";
    if (lower.includes("product")) return "We offer a wide range of nutraceutical products. Which product are you interested in?";
    if (lower.includes("contact")) return "You can reach us via the Contact page or email support@orgavitaz.com 📧";
    if (lower.includes("bye")) return "Goodbye! Have a great day! 🌟";
    return "I'm not sure about that yet 🤔, but I’ll be happy to connect you to our support team.";
  }

  // Send user message
  async function handleSend(e) {
    e?.preventDefault();
    const trimmed = text.trim();
    if (!trimmed) return;

    const userMessage = { id: `u-${Date.now()}`, role: "user", text: trimmed };
    setMessages((m) => [...m, userMessage]);
    setText("");
    setLoading(true);

    setTimeout(() => {
      const replyText = fakeBotReply(trimmed);
      const botMessage = { id: `b-${Date.now()}`, role: "bot", text: replyText };
      setMessages((m) => [...m, botMessage]);
      setLoading(false);
    }, 800);
  }

  // Press Enter to send
  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  }

  // Floating style
  const wrapperStyle = {
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 9999,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  };
   const brandStyles = {
    primaryGreen: '#91C949',
    deepBlue: '#394C92',
    linkHover: '#68A637', // Slightly darker green for hover effect
    lightBg: '#F0F5EB', // A very light, green-tinted background
};

  return (
    <div style={wrapperStyle}>
      {open ? (
        <div style={{ width: 360, maxWidth: "90vw" }}>
          {/* Close button */}
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 6 }}>
            <button
              className="btn btn-sm btn-outline-success"
              onClick={() => setOpen(false)}
            >
              ✖
            </button>
          </div>

          {/* Chat box */}
          <div className="shadow" style={{ borderRadius: 10, background: "white" }}>
            <div className="card" style={{ width: "100%" }}>
              <div className="card-header d-flex justify-content-between align-items-center">
                <strong>Support Chat</strong>
                <small className="text-muted">{loading ? "Assistant is typing…" : "Online"}</small>
              </div>

              <div className="card-body" style={{ height: 380, overflowY: "auto" }}>
                {messages.map((m) => (
                  <div key={m.id} className={`d-flex mb-3 ${m.role === "user" ? "justify-content-end" : "justify-content-start"}`}>
                    <div>
                      <div
                        className={`p-2 rounded ${m.role === "user" ? "bg-primary text-white" : "bg-light text-dark"}`}
                        style={{ maxWidth: 300, whiteSpace: "pre-wrap" }}
                      >
                        {m.text}
                      </div>
                      <div className="text-muted small mt-1">{m.role === "user" ? "You" : "Assistant"}</div>
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>

              <div className="card-footer">
                <form onSubmit={handleSend}>
                  <div className="input-group">
                    <textarea
                      className="form-control"
                      placeholder="Type your message..."
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      onKeyDown={handleKeyDown}
                      rows={1}
                    />
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                      Send
                    </button>
                  </div>
                  <div className="mt-2 text-muted small">Press Enter to send — Shift+Enter for newline.</div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <button style={{backgroundColor: brandStyles.deepBlue}}
          className="btn rounded-circle p-3 shadow"
          onClick={() => setOpen(true)}
          aria-label="Open support chat"
        >
          💬
        </button>
      )}
    </div>
  );
}
